<template>
  <div class="floating-form" :class="{ show: show }">
    <div
      class="
        p-3
        h5
        mb-0
        border-bottom border-default-dark
        bg-dark
        d-flex
        justify-content-between
        align-items-center
      "
    >
      <small class="font-weight-medium text-default-dark">
        Standoff / Drone shot
      </small>
      <button class="btn p-0 text-muted" @click="close()">
        <i class="fas fa-times" />
      </button>
    </div>
    <div class="bg-default-dark p-3">
      <p
        class="small text-muted mb-1"
        v-if="mouseCoordinate && !mouseCoordinate.isClone"
      >
        Click on map to select coordinate
      </p>
      <div class="form-group">
        <label for="standoffLatitude">
          Latitude<sup class="text-danger">*</sup>
        </label>
        <input
          id="standoffLatitude"
          type="text"
          class="form-control"
          v-model="models.lat"
          :readonly="mouseCoordinate && mouseCoordinate.isClone"
          @input="sanitizeCoordinate('lat', $event)"
        />
      </div>
      <div class="form-group">
        <label for="standoffLongitude">
          Longitude<sup class="text-danger">*</sup>
        </label>
        <input
          id="standoffLongitude"
          type="text"
          class="form-control"
          v-model="models.lng"
          :readonly="mouseCoordinate && mouseCoordinate.isClone"
          @input="sanitizeCoordinate('lng', $event)"
        />
      </div>
      <div class="form-group">
        <label
          for="standoffBearing"
          class="d-flex justify-content-between align-items-center"
        >
          <span>Angle</span>
          <span class="text-default-dark">{{ models.bearing }}&deg;</span>
        </label>
        <input
          type="range"
          class="custom-range"
          id="standoffBearing"
          v-model="models.bearing"
          min="-180"
          max="180"
          step="5"
          :readonly="
            !models.lat || (mouseCoordinate && mouseCoordinate.isClone)
          "
          :disabled="
            !models.lat || (mouseCoordinate && mouseCoordinate.isClone)
          "
        />
      </div>
      <div class="form-group">
        <label for="standoffName">Name<sup class="text-danger">*</sup></label>
        <input
          id="standoffName"
          type="text"
          class="form-control"
          v-model="models.name"
        />
      </div>
      <div class="form-group clickable" @click="showCalendarModal = true">
        <label for="layerDate">Date</label>
        <div class="form-control">
          <i class="fas fa-calendar-alt mr-2" />
          {{ models.date }}
        </div>
      </div>
      <label for="standoffImage">Image<sup class="text-danger">*</sup></label>
      <div class="custom-file">
        <input
          type="file"
          class="custom-file-input cursor-pointer"
          id="standoffImage"
          accept="image/*"
          @change="imageSelected"
        />
        <label
          class="custom-file-label text-nowrap text-truncate"
          for="standoffImage"
        >
          {{ selectedFile ? selectedFile.name : "Choose file" }}
        </label>
      </div>
    </div>
    <button class="btn btn-primary btn-block py-2" @click="save()">Save</button>
    <date-picker-modal
      v-if="showCalendarModal"
      :value="models.date"
      @close="closeCalendarModal"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DatePickerModal from "@/components/DatePickerModal";

export default {
  props: ["show", "mouseCoordinate"],
  components: {
    DatePickerModal,
  },
  data() {
    return {
      selectedFile: null,
      models: {
        name: null,
        date: null,
        lat: null,
        lng: null,
        bearing: 0,
      },
      emptyModels: {
        name: null,
        date: null,
        lat: null,
        lng: null,
        bearing: 0,
      },
      errors: [],
      showCalendarModal: false,
    };
  },
  watch: {
    show: {
      handler() {
        if (this.show && this.$el) {
          this.$el.scrollTo(0, 0);
        }

        this.models = JSON.parse(JSON.stringify(this.emptyModels));

        this.selectedFile = null;
      },
      immediate: true,
    },
    mouseCoordinate: {
      handler() {
        if (this.mouseCoordinate.lat || this.mouseCoordinate.lng) {
          this.models.lat = this.mouseCoordinate.lat;
          this.models.lng = this.mouseCoordinate.lng;
        }

        if (this.mouseCoordinate.bearing) {
          this.models.bearing = this.mouseCoordinate.bearing;
        }
      },
      deep: true,
      immediate: true,
    },
    "models.bearing"() {
      this.$emit("rotate", this.models.bearing);
    },
  },
  methods: {
    closeCalendarModal(e) {
      this.showCalendarModal = false;

      if (e !== "close") {
        this.models.date = e;
      }
    },
    async save() {
      this.errors = [];

      if (!this.models.name) {
        this.errors.push("Name is required");
      }

      if (!this.models.lat) {
        this.errors.push("Latitude is required");
      }

      if (!this.models.lng) {
        this.errors.push("Longitude is required");
      }

      if (!this.selectedFile) {
        this.errors.push("Image is required");
      }

      if (this.errors.length > 0) {
        Swal.fire({
          title: "<h5>Error</h5>",
          html: `<div class='line-height-md'>${this.errors.join(
            "<br />"
          )}</div>`,
          icon: "error",
        });
      } else {
        this.$emit("toggle-spinner", true);

        let formData = new FormData();

        formData.append(
          "files.media",
          this.selectedFile,
          this.selectedFile.name
        );

        let body = JSON.parse(JSON.stringify(this.models));

        body.site = this.$route.params.id;

        if (!body.bearing) {
          body.bearing = 0;
        }

        formData.append("data", JSON.stringify(body));

        const [call, err] = await this.Helper.handle(
          this.API.postForm("site-standoffs", formData)
        );

        if (!err && call.status == 200) {
          this.$emit("toggle-spinner", false);

          Swal.fire("<h5 class='mb-0'>Shot added</h5>", "", "success").then(
            () => {
              this.$emit("close", call.data);
            }
          );
        } else if (err) {
          this.$emit("toggle-spinner", false);

          Swal.fire("<h5 class='mb-0'>Error</h5>", err.message, "error");
        }
      }
    },
    sanitizeCoordinate(type, e) {
      this.models[type] = this.Helper.sanitizeNumber(e.target.value);
    },
    close(e) {
      const fileInput = document.getElementById("standoffImage");

      if (fileInput) {
        fileInput.value = null;
      }

      this.$emit("close", e);
    },
    imageSelected(e) {
      this.selectedFile = e.target.files[0];
    },
  },
};
</script>